export const JOBS_BOARD_FETCH_STARTED = 'JOBS_BOARD_FETCH_STARTED';
export const JOBS_BOARD_FETCH_COMPLETED = 'JOBS_BOARD_FETCH_COMPLETED';
export const JOBS_BOARD_FETCH_FAILED = 'JOBS_BOARD_FETCH_FAILED';

export const JOBS_BOARD_CHANGE_STATUS_STARTED = 'JOBS_BOARD_CHANGE_STATUS_STARTED';
export const JOBS_BOARD_CHANGE_STATUS_COMPLETED = 'JOBS_BOARD_CHANGE_STATUS_COMPLETED';
export const JOBS_BOARD_CHANGE_STATUS_FAILED = 'JOBS_BOARD_CHANGE_STATUS_FAILED';
